import React, { useState, useEffect } from "react";
import BenchPress from "../../styles/Assets/bench-press.png";
import Dumbbell from "../../styles/Assets/dumbbells.png";
import Skipping from "../../styles/Assets/skipping-rope.png";
import Treadmill from "../../styles/Assets/treadmill.png";
import WaterBottle from "../../styles/Assets/water-bottle.png";

const GymEquipmentLoader = ({
  title = "",
  progress = 0,
  showProgress = false,
}) => {
  const equipmentList = [
    "benchpress",
    "dumbbell",
    "skipping",
    "treadmill",
    "water",
  ];

  const [currentEquipment, setCurrentEquipment] = useState(
    equipmentList[Math.floor(Math.random() * equipmentList.length)]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      let newEquipment;
      do {
        newEquipment =
          equipmentList[Math.floor(Math.random() * equipmentList.length)];
      } while (newEquipment === currentEquipment && equipmentList.length > 1);

      setCurrentEquipment(newEquipment);
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEquipment, equipmentList.length]);

  const getEquipmentIcon = (equipment) => {
    const icons = {
      benchpress: BenchPress,
      dumbbell: Dumbbell,
      skipping: Skipping,
      treadmill: Treadmill,
      water: WaterBottle,
    };
    return icons[equipment] || Dumbbell;
  };

  return (
    <div className="loader-wrapper">
      <div className="moon-loader-container">
        <div className="spinner"></div>
        <img
          src={getEquipmentIcon(currentEquipment)}
          alt={currentEquipment}
          className="center-equipment"
        />
      </div>

      {/* Progress bar and percentage - now directly under loader */}
      {showProgress && (
        <div className="progress-container">
          <div
            className="progress-fill"
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
          <div className="progress-text fw-bold fs-5">{Math.round(progress)} %</div>
        </div>
      )}

      {/* Display title/text */}
      {title && <p className="loader-title">{title}</p>}
    </div>
  );
};

export default GymEquipmentLoader;
